import * as React from "react";
import PopDetail from "../../popdetail";
import CreateService from "../../../service/create";
import Wait from "../../wait";
import GeneralSelect from "../../general_select";


export default class AllocatePlotPane extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            parties: {endpoint: `spatial/${this.props.project.id}/list/parties`, value: 'id', label: 'fullname', placeholder: 'Select Parties'},
        }
        this.setPageAt = this.setPageAt.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        this.saveParty = this.saveParty.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.saveAllocation = this.saveAllocation.bind(this)
    }

    handleChanges=(e)=> { this.setState({[e.target.name]: e.target.value}) }
    handleFileChanges = async (event) => { await this.setState({[event.target.name]: event.target.files[0]}) }
    generalSelect(data,name) {
         this.setState({
             [name]: data
         })
    }

    setPageAt(i){
        this.setState({
            current_tab:i
        })
    }
    render() {
        return(<div style={{minHeight:'70vh'}}>

            <table style={{width:'100%'}}>
                <tbody>

                <tr>
                    <td>

                        <span className={'label'}>Plots</span>

                        <div style={{fontSize:'32px',fontWeight:900,padding:'24px',float:'left',width:'96%',background:'#efefef',border:'1px solid #ccc'}}>
                            {this.props.description.map((d,i)=>{
                                return(<span key={i} style={{float:'left',marginRight:'8px'}} className={'badge'}>{d}</span>)
                            })}
                        </div>


                         {/*<div>
                             <span className={'label'}>Occupancy Type</span>
                             <select style={{width:'100%'}}>
                                 <option>- Select One -</option>
                             </select>
                         </div>*/}

                        <div>
                             <span className={'label'}>Party / Parties</span>
                            <GeneralSelect onChanges={(e)=>this.generalSelect(e,'parties')} parameters={this.state.parties} isMulti={true}/>

                        </div>


                         <div id={'tb_add_party'} style={{padding:'8px',display:'none',background:'#efefef',border:'1px solid #ccc',marginTop:'8px',borderRadius:'2px'}}>
                             <table style={{width:'100%'}}>
                             <tbody>
                             <tr>
                                 <td className={'label'}>Jina la Kwanza</td>
                                 <td className={'label'}>Jina la Kati</td>
                                 <td className={'label'}>Jina la Ukoo</td>
                             </tr>
                             <tr>
                                 <td><input style={{width:'97%'}} name={'first_name'} onChange={this.handleChanges}/></td>
                                 <td><input style={{width:'97%'}} name={'middle_name'} onChange={this.handleChanges}/></td>
                                 <td><input style={{width:'97%'}} name={'last_name'} onChange={this.handleChanges}/></td>
                             </tr>
                             <tr>
                                 <td className={'label'}>Jinsia</td>
                                 <td className={'label'}>Tarehe ya Kuzaliwa</td>
                                 <td className={'label'}>Picha ya MMiliki</td>
                             </tr>
                             <tr>
                                 <td>
                                     <select style={{width:'100%'}} name={'gender'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option>Male</option>
                                         <option>Female</option>
                                     </select>
                                 </td>
                                 <td><input type={'date'} style={{width:'97%'}} name={'dob'} onChange={this.handleChanges}/></td>
                                 <td><input type={'file'} style={{width:'97%',padding:'6px',background:'#fff'}} name={'dp'} accept={".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"} onChange={this.handleFileChanges}/></td>
                             </tr>
                             <tr>
                                 <td className={'label'}>Phone Number</td>
                                 <td className={'label'}>Email</td>
                                 <td className={'label'}>Address / Postal Code</td>
                                 <td className={'label'}>Occupation</td>
                             </tr>

                             <tr>
                                 <td><input type={'number'} style={{width:'97%'}} name={'phone'} onChange={this.handleChanges}/></td>
                                 <td><input type={'email'} style={{width:'97%'}} name={'email'} onChange={this.handleChanges}/></td>
                                 <td><input type={'text'} style={{width:'97%'}} name={'address'} onChange={this.handleChanges}/></td>
                                 <td><input type={'text'} style={{width:'98%'}} name={'occupation'} onChange={this.handleChanges}/></td>
                             </tr>

                             <tr>
                                 <td className={'label'}>Makazi</td>
                                 <td className={'label'}>Aina ya Kitambulisho</td>
                                 <td className={'label'}>Namba ya Kitambulisho</td>
                                 <td className={'label'}>Picha ya Kitambulisho</td>
                             </tr>
                             <tr>
                                 <td>
                                     <select style={{width:'100%'}} name={'makazi'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option>Mkazi</option>
                                         <option>Si Mkazi</option>
                                     </select>
                                 </td>
                                 <td>
                                     <select style={{width:'100%'}} name={'idType'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option>Kitambulisho Cha Taifa</option>
                                         <option>Leseni ya Udereva</option>
                                         <option>Mpiga Kura</option>
                                         <option>Barua ya Utambulisho</option>
                                     </select>
                                 </td>
                                 <td><input type={'text'} style={{width:'97%'}} name={'idNo'} onChange={this.handleChanges}/></td>
                                 <td><input type={'file'} style={{width:'97%',padding:'6px',background:'#fff'}} name={'idPic'}  accept={".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"} onChange={this.handleFileChanges}/></td>
                             </tr>
                             <tr>
                                 <td className={'label'}>Kuhusu Umiliki</td>
                                 <td className={'label'}>Alipajae Eneo Hili</td>
                                 <td className={'label'}>Kuhusu Ndoa</td>
                                 <td className={'label'}>Ulemavu</td>
                             </tr>
                             <tr>
                                 <td>
                                     <select style={{width:'100%'}} name={'role'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option value={'Owner'}>Owner</option>
                                         <option value={'Guardian'}>Guardian</option>
                                         <optgroup label={'Beneficiary'}>
                                             <option value={'wife'}>Wife</option>
                                            <option value={'husband'}>Husband</option>
                                            <option value={'child'}>Child</option>
                                            <option value={'relative'}>Relative</option>
                                         </optgroup>
                                     </select>
                                 </td>
                                 <td>
                                     <select style={{width:'100%'}} name={'acquire'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option>Alinunua</option>
                                         <option>Alipewa</option>
                                         <option>Alirithi</option>
                                         <option>Alivamia</option>
                                     </select>
                                 </td>
                                 <td>
                                     <select style={{width:'100%'}} name={'marital'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option>Ameoa / Ameolewa</option>
                                         <option>Hajaoa / Hajaolewa</option>
                                         <option>Mgane / Mjane</option>
                                         <option>Taraka</option>
                                     </select>
                                 </td>
                                 <td>
                                     <select style={{width:'100%'}} name={'disability'} onChange={this.handleChanges}>
                                         <option>- Choose One -</option>
                                         <option>Hana</option>
                                         <option>Ngozi</option>
                                         <option>Akili</option>
                                         <option>Macho</option>
                                         <option>Kuzungumza</option>
                                         <option>Jinsia</option>
                                     </select>
                                 </td>
                             </tr>
                             <tr>
                                 <td colSpan={4}>
                                     <button className={'btn refresh'} onClick={this.saveParty}>
                                         <span className={'fa fa-save'}/>Save
                                     </button>
                                     <button className={'btn error'} onClick={()=>{
                                         //PopDetail.dismiss()
                                         document.getElementById('tb_add_party').style.display='none'
                                         document.getElementById('bt_add_party').style.display='block'
                                         document.getElementById('div-allocate').style.display='block'
                                     }}>
                                         <span className={'fa fa-times'}/>Close
                                     </button>
                                 </td>
                             </tr>
                             </tbody>
                         </table>
                         </div>

                         <u id={'bt_add_party'} className={'label'} style={{cursor:'pointer'}} onClick={()=>{
                             document.getElementById('bt_add_party').style.display='none'
                             document.getElementById('tb_add_party').style.display='block'
                             document.getElementById('div-allocate').style.display='none'
                         }}>
                             <span className={'fa fa-plus'}/>Add New Party
                         </u>
                    </td>
                </tr>

                </tbody>
            </table>


            <div style={{marginTop:'16px'}} id={'div-allocate'}>
                <button className={'btn submit'} onClick={this.saveAllocation}>
                    <span className={'fa fa-save'}/>Allocate
                </button>
                <button className={'btn error'} onClick={PopDetail.dismiss}>
                    <span className={'fa fa-times'}/>Close
                </button>
            </div>

        </div>)
    }

   
    saveParty(){
        let first_name = this.state.first_name
        let middle_name = this.state.middle_name
        let last_name = this.state.last_name
        let gender = this.state.gender
        let dob = this.state.dob
        let dp = this.state.dp
        let makazi = this.state.makazi
        let idType = this.state.idType
        let idNo = this.state.idNo
        let role = this.state.role
        let acquire = this.state.acquire
        let marital = this.state.marital
        let disability = this.state.disability
        let phone = this.state.phone
        let email = this.state.email
        let address = this.state.address
        let occupation = this.state.occupation

        try{
            if (first_name===undefined){ alert('No First Name'); return}
            if (middle_name===undefined){ alert('No Middle Name'); return}
            if (last_name===undefined){ alert('No Last Name'); return}
            if (gender===undefined){ alert('No Gender'); return }
            if (dob===undefined){ alert('No Date Of Birth'); return }
            if (dp===undefined){ alert('No Picture'); return }
            if(phone===undefined){ alert('No Phone Number');return }
            if (makazi===undefined){ alert('No Makazi'); return }
            if (role===undefined){ alert('No Party Role'); return }
            if (acquire===undefined){ alert('No acquire'); return }
            if (marital===undefined){ alert('No marital'); return }

        }catch (e) {
            console.log(e)
        }

        const formData = new FormData()
        formData.append('dp',this.state.dp)
        formData.append('idPic',this.state.idPic)
        formData.append('extra',JSON.stringify({
            project_id: this.props.project.id,
            first_name:first_name,
            middle_name:middle_name,
            last_name:last_name,
            gender:gender,
            phone:phone,
            email:email,
            address:address,
            occupation:occupation,
            dob:dob,
            makazi:makazi,
            idType:idType,
            idNo:idNo,
            role:role,
            acquire:acquire,
            marital:marital,
            disability:disability,
            deedplanId:this.props.deedplan
        }))

        try {
            Wait.show('Saving Party....')
            CreateService.createParty(formData).then(r=>{
                Wait.dismiss()
               /* if (r.data.status===1){
                    return
                }*/
                //PopDetail.dismiss()
                //this.props.loadData()
                this.setState({
                    parties: {endpoint: `spatial/${this.props.project.id}/list/parties`, value: 'id', label: 'label', placeholder: 'Select Parties'},
                })

                document.getElementById('bt_add_party').style.display='block'
                document.getElementById('tb_add_party').style.display='none'
                document.getElementById('div-allocate').style.display='block'

            })
        }catch (e) {
            console.log(e)
        }

    }

    saveAllocation(){
        let parties = this.state.parties
        let plots = this.props.description

        try{
            if (parties===undefined || !Array.isArray(parties) || parties.length===0){ 
                alert('Please select at least one party'); 
                return
            }
            if (plots===undefined || !Array.isArray(plots) || plots.length===0){ 
                alert('No plots selected'); 
                return
            }
        }catch (e) {
            console.log(e)
        }

        let data = {
            project_id: this.props.project.id,
            deedplanId: this.props.deedplan,
            parties: Array.isArray(parties) ? parties.map(p=>p.value || p.id || p) : [],
            plots: plots
        }

        try {
            Wait.show('Allocating Plots....')
            CreateService.createAllocation(data).then(r=>{
                Wait.dismiss()
                if (r && r.data && r.data.status===1){
                    alert('Allocation saved successfully')
                    PopDetail.dismiss()
                    if (this.props.loadData) {
                        this.props.loadData()
                    }
                } else {
                    alert('Error saving allocation')
                }
            }).catch(e=>{
                Wait.dismiss()
                console.log(e)
                alert('Error saving allocation')
            })
        }catch (e) {
            Wait.dismiss()
            console.log(e)
            alert('Error saving allocation')
        }

    }
}